import { Text } from '@croquiscom-pvt/zds';

import { numberWithCommas } from '@common/utils';

interface ItemCardPriceProps {
  price: number;
  count: number;
}

export const ItemCardPrice = ({ price, count }: ItemCardPriceProps) => {
  const total_price = price * count;

  return (
    <Text variant='Body_15_SemiBold' v3Color='gray700'>
      {numberWithCommas(total_price)}원
    </Text>
  );
};
